<script>
export default {
  props: ["clr"]
};
</script>
<template>
  <svg
    id="selfie-photo"
    xmlns="http://www.w3.org/2000/svg"
    width="28"
    height="28"
    viewBox="0 0 28 28"
  >
    <g id="Group_1052" data-name="Group 1052" transform="translate(3.5 3.5)">
      <path
        id="Path_8459"
        data-name="Path 8459"
        d="M21.667,24H5.333A2.333,2.333,0,0,1,3,21.667V5.333A2.333,2.333,0,0,1,5.333,3H21.667A2.333,2.333,0,0,1,24,5.333V21.667A2.333,2.333,0,0,1,21.667,24Z"
        transform="translate(-3 -3)"
        fill="none"
        :stroke="clr ? clr : '#500fe9'"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="2"
      />
      <path
        id="Path_8460"
        data-name="Path 8460"
        d="M15.475,8.025a3.5,3.5,0,1,1-4.95,0,3.5,3.5,0,0,1,4.95,0M6,23.333l.417-2.081A4.666,4.666,0,0,1,10.992,17.5h4.016a4.666,4.666,0,0,1,4.576,3.752L20,23.333"
        transform="translate(-2.5 -2.333)"
        fill="none"
        :stroke="clr ? clr : '#500fe9'"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="2"
      />
    </g>
    <path id="Path_8461" data-name="Path 8461" d="M0,0H28V28H0Z" fill="none" />
  </svg>
</template>
